import { observer } from "mobx-react";
import React from "react";
import { IOption } from "../Utils/Interface";
import Popover from "./Popover";
import { generalConfigurationStore } from "../Stores/GeneralConfigurationStore";

type Props = {
	headline: string;
	options?: IOption[];
	popoverDescription?: string;
	value?: IOption;
	canSelectOption?: (option: IOption) => boolean;
	onChange: (option: IOption) => void;
	showEmptyOption: boolean;
};

type State = {
	isPopoverOpen: boolean;
};

@observer
class Selection extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly
		this.state = {
			isPopoverOpen: false,
		};
	}

	handlePopover = (e: any) => {
		e.preventDefault();

		this.setState({ isPopoverOpen: !this.state.isPopoverOpen });

		if (!this.state.isPopoverOpen) {
			document.body.style.overflowY = "hidden";
		} else {
			document.body.style.overflowY = "unset";
		}
	};

	handleSelect = (e: any) => {
		const id = e.target.value;
		if (id) {
			// find option for id
			const option = this.props.options?.find((option) => {
				return option.id === id;
			});

			if (option) {
				this.props.onChange(option);
				return;
			} else if (this.props.value) {
				this.props.onChange(this.props.value); // toggle
			}
		}
	};

	render() {
		return (
			<>
				<div className="single-select-wrapper">
					<div className="selection-headline-wrapper no-border pb-4">
						<h4 className="selection-headline">{this.props.headline}</h4>
						{this.props.popoverDescription && <div className="module-popover" onClick={this.handlePopover}></div>}
						{this.props.popoverDescription && this.state.isPopoverOpen && (
							<Popover
								headline={this.props.headline}
								description={this.props.popoverDescription}
								position={"position-lg-relative"}
								onClose={() => {
									this.setState({ isPopoverOpen: !this.state.isPopoverOpen });
									if (!this.state.isPopoverOpen) {
										document.body.style.overflowY = "hidden";
									} else {
										document.body.style.overflowY = "unset";
									}
								}}
							/>
						)}
					</div>
					<select
						className={`single-select form-control form-control-lg`}
						onChange={this.handleSelect}
						value={this.props.value?.id}
						required={true}
					>
						{this.props.showEmptyOption && <option value={undefined}>{generalConfigurationStore.configs?.generalSelectFieldPlaceholder}</option>}
						{this.props.options?.map((option) => {
							return (
								<option disabled={this.props.canSelectOption ? !this.props.canSelectOption(option) : false} key={`${option.id}`} value={option.id}>
									{option.name}
								</option>
							);
						})}
					</select>
				</div>
			</>
		);
	}
}

export default Selection;
